import React, { Component } from "react";
import classnames from "classnames";
import moment from "moment";
import _ from "i18n";
import { TiWarningOutline } from "react-icons/ti";
import { TrelloIcon } from "../Common/Icons";
import styles from "./ModalEmaillingContent.local.scss";

class ModalEmaillingContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      showMore: false
    };
  }
  handleShowMore = () => {
    this.setState({
      showMore: true
    });
  };
  handleSendEmail = (recipients, data, organization, modelType) => {
    const {
      model: { disabled },
      sending
    } = this.props;
    if (disabled || sending) {
      return;
    }
    let dynamicFields = {};
    let recipientsResult = {};
    // eslint-disable-next-line array-callback-return
    recipients.map(recipient => {
      recipientsResult[recipient.id] = recipient.email;
    });
    let recipientEmails = recipients.map(recipient => recipient.email);

    Object.assign(dynamicFields, {
      "{{CLIENT}}": organization
    });
    Object.assign(dynamicFields, {
      "{{PRESENTATION.DATE}}": data.datePresentation
        ? data.datePresentation
        : "--"
    });
    Object.assign(dynamicFields, {
      "{{PRESENTATION.URL}}": data.url ? data.url : "javascript: void(0)"
    });
    Object.assign(dynamicFields, {
      "{{PRESENTATION.URL.EXPIRES}}": data.expires ? data.expires : "--"
    });
    Object.assign(dynamicFields, {
      "{{PRESENTATION.YEAR}}": data.year
    });
    Object.assign(dynamicFields, {
      "{{PRESENTATION.STATE}}": data.state
    });

    this.props.onSendEmail(
      recipientsResult,
      modelType,
      dynamicFields,
      recipientEmails,
      data,
      organization
    );
  };

  repalaceVariableWithData = (text, model, organizationName) => {
    let result = null;
    result = text.replace("{{RECIPIENT.FN}}", "first-name");
    result = result.replace("{{RECIPIENT.LN}}", "last-name");
    result = result.replace("{{RECIPIENT.EMAIL}}", "email");
    result = result.replace("{{CLIENT}}", organizationName);
    result = result.replace(
      "{{PRESENTATION.DATE}}",
      model.datePresentation ? model.datePresentation : "--"
    );
    result = result.replace(
      "{{PRESENTATION.URL}}",
      model.url ? model.url : "javascript: void(0)"
    );
    result = result.replace(
      "{{PRESENTATION.URL.EXPIRES}}",
      model.expires ? model.expires : "--"
    );
    result = result.replace("{{PRESENTATION.YEAR}}", model.year);
    result = result.replace("{{PRESENTATION.STATE}}", _(model.state));

    return result;
  };

  render() {
    const {
      model: {
        modelType,
        clientName,
        datePresentation,
        description,
        year,
        state,
        disabled,
        textButton,
        modelCode,
        url
      },
      lng,
      index,
      model,
      history,
      sending,
      sentModel,
      recipients,
      organization
    } = this.props;
    moment.locale(lng);
    let justSent = false;
    let justSentTo = [];
    history &&
      history.forEach(element => {
        let historyMails = element.recipient
          .replaceAll('"', "")
          .slice(0, -1)
          .substring(1)
          .split(",");
        let includes = false;
        historyMails.forEach(element => {
          if (recipients.map(item => item.email).includes(element)) {
            includes = true;
          }
        });
        if (
          new Date().getTime() - new Date(element.date).getTime() < 10800000 &&
          recipients.length > 0 &&
          includes
        ) {
          justSent = true;
          justSentTo.push(element.recipient);
        }
      });
    let alreadySent = null;
    let recipientEmails = null;
    if (history && history.length > 0) {
      alreadySent = history[0];
      recipientEmails = history[0].recipient
        .slice(0, -1)
        .substring(1)
        .split(",");
    }

    return (
      <div
        className={classnames(
          styles.container,
          disabled ? styles.disabled : ""
        )}
        key={`mail-model${index}`}
      >
        <p className={styles.modal_type}>{modelType}</p>
        <p className={styles.modal_name}>
          {_("balanceSheet")} {clientName} {year}
        </p>
        <div className={styles.modal_infos}>
          <TrelloIcon
            fill={"#6D7F92"}
            size={13}
            className={styles.modal_trelloicon}
          />
          <span>{_(state)}</span>
        </div>
        <div className={styles.modal_infos}>
          <img alt={""} src={"/img/icons/calendar.svg"} />
          <span>
            {datePresentation
              ? `${_("datePresentation")} : ${datePresentation}`
              : _("undefinedDate")}
          </span>
        </div>
        <div className={styles.modal_infos}>
          <img alt={""} src={"/img/icons/link.svg"} />
          <span>{url ? _("linkGenered") : _("linkNotGenered")} </span>
        </div>
        <div
          className={classnames(
            styles.modal_description,
            !this.state.showMore ? styles.short_modal_description : ""
          )}
          dangerouslySetInnerHTML={{
            __html: this.repalaceVariableWithData(
              this.state.showMore ? description : description.substring(0, 380),
              model,
              organization
            )
          }}
        />
        {description.length > 400 && (
          <span
            onClick={() => this.handleShowMore()}
            className={styles.show_more}
          >
            {this.state.showMore ? "" : `${_("showMore")}`}
          </span>
        )}
        <button
          className={classnames(
            styles.modal_button,
            recipients.length === 0 ? styles.disabled : ""
          )}
          disabled={recipients.length === 0}
          onClick={() =>
            this.handleSendEmail(recipients, model, organization, modelCode)
          }
        >
          {alreadySent && !sending && <TiWarningOutline />}
          <img
            src={"/img/icons/tail-spin.svg"}
            alt={""}
            className={sending && sentModel === modelCode ? styles.loading : ""}
          />
          {_(alreadySent ? "resendAgain" : textButton)}
        </button>
        {justSent ? (
          <div className={styles.modal_danger}>
            * {_("justSentToRecipients")}
          </div>
        ) : alreadySent ? (
          <div className={styles.modal_warning}>
            <span>
              * {_("sentTo")}{" "}
              <strong>{`${recipientEmails.length} ${_(
                recipientEmails.length > 1 ? "recipients" : "recipient"
              )}`}</strong>{" "}
              {moment(alreadySent.date, "YYYY-MM-DD hh:mm:ss").fromNow()}
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default ModalEmaillingContent;



// WEBPACK FOOTER //
// ./src/components/FicheClient/ModalEmaillingContent.js